import { DEMO_TODAY } from './fixtures';

/**
 * How the mock screens write amounts and days. A day is an ISO date with no time, read and written
 * in UTC, so it is never shown as the evening before west of Greenwich — the live screens' rule
 * (`components/days.ts`), kept apart because a mock imports nothing of the admin domain's own.
 */

const DAY = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });

export function day(iso: string): string {
  const parsed = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  return Number.isNaN(parsed.getTime()) ? iso : DAY.format(parsed);
}

/** Days from the demo's today to `iso` — negative once it has passed. */
export function daysUntil(iso: string): number {
  const from = Date.parse(`${DEMO_TODAY}T00:00:00Z`);
  const to = Date.parse(`${iso.slice(0, 10)}T00:00:00Z`);
  return Math.round((to - from) / 86_400_000);
}

export function dueLabel(iso: string): string {
  const days = daysUntil(iso);
  if (days < 0) return `${-days} day${days === -1 ? '' : 's'} overdue`;
  if (days === 0) return 'Due today';
  return `Due in ${days} day${days === 1 ? '' : 's'}`;
}

/** An amount in US dollar millions, as a list reads it: `$2,350M`, `$11.8M`. */
export function millions(value: number): string {
  const digits = value < 100 && !Number.isInteger(value) ? 1 : 0;
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: 1 })}M`;
}
